import { Routes } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HUMAN_RESOURCES_ROUTES } from './components/human-resources/human-resources.routes';
import { HrService } from './services/human-resources/hr.service';
import { NotificationService } from './services/human-resources/notification.service';
import { AuthDebugComponent } from './components/auth-debug.component';
import { authInterceptor } from './services/auth-interceptor';
import { LoginComponent } from './components/human-resources/login/login.component';

// Create simple routes
export const routes: Routes = [
  // Root route redirects to HR
  {
    path: '',
    redirectTo: 'hr',
    pathMatch: 'full'
  },

  // Auth debug route
  {
    path: 'auth-debug',
    component: AuthDebugComponent
  },

  // Login route
  {
    path: 'login',
    component: LoginComponent
  },

  // HR panel
  {
    path: 'hr',
    providers: [
      provideHttpClient(withInterceptors([authInterceptor])),
      { provide: HrService, useClass: HrService },
      { provide: NotificationService, useClass: NotificationService }
    ],
    children: HUMAN_RESOURCES_ROUTES
  }
]; 